/* Si accorge da solo quando il sito è stato aggiornato e lo ricarica (niente più Ctrl+F5). */
import { useEffect } from "react";
import { toast } from "sonner";

const current = () => [...document.scripts].map((s) => s.src).find((src) => /\/static\/js\/main\.[^/]+\.js/.test(src))?.match(/main\.[^/]+\.js/)?.[0];

export default function UpdateChecker() {
  useEffect(() => {
    const mine = current();
    if (!mine) return undefined; // in sviluppo (npm start) non serve
    let shown = false;
    const check = async () => {
      if (shown) return;
      try {
        const m = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: "no-store" }).then((r) => r.json());
        const latest = m?.files?.["main.js"]?.split("/").pop();
        if (latest && latest !== mine) {
          shown = true;
          // se la pagina non è in primo piano ricarica subito, altrimenti avvisa e ricarica tra poco
          if (document.hidden) return window.location.reload();
          toast("È disponibile una nuova versione del pannello", {
            description: "Si aggiorna da sola tra 15 secondi. Salva prima eventuali modifiche.",
            duration: 15000, icon: "✨",
            action: { label: "Aggiorna ora", onClick: () => window.location.reload() },
            onAutoClose: () => window.location.reload(),
          });
        }
      } catch { /* offline: riprova dopo */ }
    };
    const t = setInterval(check, 60000);
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); document.removeEventListener("visibilitychange", onFocus); };
  }, []);
  return null;
}
